import React from 'react'
import { Table, Input, Button, List } from 'antd';
import { PlusCircleOutlined } from '@ant-design/icons'

import {
  Mobile,
  DefaultDevice
} from './../../utils/mediaQuery'
import { ExportCSV } from '@components';

const { Search } = Input;

export default function LarpTable({
    setSearchValue,
    refresh,
    columns,
    dataSource,
    listSource,
    onRowClick,
    onDoubleRowClick,
    setIsAddModalVisible,
    addLabel,
    onAddSkillClick,
    defaultPageSize = 10,
    onTableChange,
    csv
}) {

    function onSearch(searchValue)
    {
      setSearchValue(searchValue.target.value);
    }

    function getTable() {
      return <Table 
      size={'small'}
      rowKey={'id'}
      columns={columns} 
      dataSource={dataSource} 
      scroll={{x:"110px"}}
      onChange={onTableChange && onTableChange}
      pagination={{ defaultPageSize: defaultPageSize, showSizeChanger: true, pageSizeOptions: ['10', '20', '30', '50', '100']}}

          onRow={(record, rowIndex) => {
            return {
            onClick: event => {onRowClick && onRowClick(record)}, // click row
            onDoubleClick: event => {onDoubleRowClick && onDoubleRowClick(record)}, // double click row
            onContextMenu: event => {}, // right button click row
            onMouseEnter: event => {}, // mouse enter row
            onMouseLeave: event => {}, // mouse leave row
            };
        }}
    />
    }

    return (
        <>
            {setSearchValue &&
              <Search
                placeholder="input search text"
                // onSearch={onSearch}
                onChange={onSearch}
                enterButton 
              />
            }
            {refresh && <Button onClick={refresh} >
              Refresh
            </Button>}
            {onAddSkillClick && <Button size="large" type="primary" icon={<PlusCircleOutlined />} shape="circle" onClick={onAddSkillClick} /> }
            {setIsAddModalVisible && <Button onClick={() => setIsAddModalVisible(true)}>
              {addLabel}
            </Button>}
            {csv && <ExportCSV csvData={csv.data} csvHeaders={csv.headers} csvFileName={csv.fileName} />}
            {(refresh || csv) && <br /> }
            {(refresh || csv) && <br /> }
            <Mobile>
            {listSource ? <List
                itemLayout="horizontal"
                dataSource={listSource}
                pagination={{
                  pageSize: 10,
                }}
                renderItem={item =>
                  item
                }
              /> 
              : getTable()
              }
            </Mobile>
            <DefaultDevice>
              {getTable()}
            </DefaultDevice>
        </>
    )
}